<template>
    
        <div class="relative" v-for="post in recentPosts" 
            :key="post.id">
            <BlogPostCardMinimal v-if="use === 'minimal'" :post="post"></BlogPostCardMinimal>
            <BlogPostCard v-else :post="post"></BlogPostCard>
        </div>
   
</template>

<script lang="ts" setup>
// @ts-ignore
import {computed, defineProps, onMounted, Ref, ref} from "vue";
import {client} from '@/shared';
import {
    BlogPostDtoLightweight,
    GetRecentPostsForWidgetRequest
} from "@/dtos";

import BlogPostCard from "./BlogPostCard.vue";
import BlogPostCardMinimal from "./BlogPostCardMinimal.vue";

const props = defineProps({
    numOfPosts: {
        type: Number,
        default: 6
    },
    use: {
        type: String,
        default: "card"
    },
})

const use = ref(props.use);

let recentPosts: Ref<BlogPostDtoLightweight[]> = ref([]);

onMounted(async () => {
    await getRecentPostsForWidget();
});

const getRecentPostsForWidget = async () => {
    await client.get<any>(new GetRecentPostsForWidgetRequest({ pageSize: props.numOfPosts}))
        .then(response => {
            recentPosts.value = response.results;
        });
}
</script>
<style>

</style>